import { Component } from '@opten/gin-tonic/helpers/compiler';
import { Dialog } from '@opten/gin-tonic/components/dialog';

@Component({className: 'js-dialog'})
export class DialogComponent {
	constructor(private element: HTMLDialogElement) {
		const dialog = new Dialog(element);

		element.addEventListener('opened.opten.dialog',() => {
			const callToActionButtons = dialog.getInstance().querySelectorAll('.js-call-to-action');
			if(callToActionButtons != null && callToActionButtons.length > 0){
				callToActionButtons.forEach(o => {
					const href = o.getAttribute('href');
					const target = o.getAttribute('target');
					if(href?.indexOf('#') && target != null && target === '_self'){
						o.addEventListener('click',(e) => {
							e.preventDefault();
							window.location.href = href;
							dialog.close();
						})
					}
				})
			}
		});
	}
}
